import React from "react";

type StatusLineTone = "muted" | "positive";

interface StatusLineProps {
    tone: StatusLineTone;
    children: React.ReactNode;
}

const toneClasses: Record<StatusLineTone, string> = {
    muted: "text-gray-500",
    positive: "text-green-600",
};

export const StatusLine: React.FC<StatusLineProps> = props => {
    const { tone, children } = props;
    return (
        <div className={`mt-1 flex items-center gap-1 text-xs ${toneClasses[tone]}`}>
            {children}
        </div>
    );
};
